import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { ITemplateTargetResult } from './ITemplateTargetResult'

export class TemplateTargetResult extends Entity<ITemplateTargetResult> {
  id: number
  name: string

  public static new(payload: ITemplateTargetResult): TemplateTargetResult {
    return plainToInstance(TemplateTargetResult, payload)
  }
}
